// extracted by mini-css-extract-plugin
export default {"linkReport":"LinkToReports_linkReport__c12uo","reportsLink":"LinkToReports_reportsLink__0jDZE","text":"LinkToReports_text__WsztP","icon":"LinkToReports_icon__-u6rX"};